import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b7d44a0c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "order-card-header" }
const _hoisted_2 = { class: "d-flex justify-content-between" }
const _hoisted_3 = { class: "order-card-detail mr-2 d-flex flex-column justify-content-between" }
const _hoisted_4 = { class: "order-card-title order-card-title--break mb-1 text-size-14" }
const _hoisted_5 = { class: "d-flex align-items-center" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "d-flex flex-column text-mild align-items-start text-size-17 mt-2" }
const _hoisted_8 = { class: "work-time-option-list" }
const _hoisted_9 = { class: "d-flex align-items-center" }
const _hoisted_10 = { class: "d-flex align-items-center salary-per-day-with-various-allowances" }
const _hoisted_11 = { class: "mt-1 d-flex" }
const _hoisted_12 = { class: "ml-auto hourly-wage" }
const _hoisted_13 = { class: "office-info mt-2" }
const _hoisted_14 = { class: "d-flex align-items-center flex-wrap" }
const _hoisted_15 = { class: "mr-2 office-name" }
const _hoisted_16 = {
  key: 1,
  class: "text-mild text-size-12 wait-fetch-evaluation"
}
const _hoisted_17 = { class: "d-flex justify-content-between pl-1" }
const _hoisted_18 = { class: "office-info-detail" }
const _hoisted_19 = { class: "d-flex align-items-center text-mild text-size-12" }
const _hoisted_20 = { class: "office-info-address" }
const _hoisted_21 = { class: "d-flex align-items-center text-mild text-size-12 mt-1" }
const _hoisted_22 = { class: "office-info-access" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OrderLabel = _resolveComponent("OrderLabel")!
  const _component_WatchLaterButton = _resolveComponent("WatchLaterButton")!
  const _component_BeginnerMark = _resolveComponent("BeginnerMark")!
  const _component_RemainingDateTime = _resolveComponent("RemainingDateTime")!
  const _component_BImgLazy = _resolveComponent("BImgLazy")!
  const _component_FeatherIcon = _resolveComponent("FeatherIcon")!
  const _component_EvaluationWithCount = _resolveComponent("EvaluationWithCount")!

  return (_openBlock(), _createElementBlock("div", {
    role: "button",
    class: _normalizeClass(["d-block order-card", { 'is-closed-order': !_ctx.isOpenedOrder }]),
    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('card-click', _ctx.order.id)))
  }, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_OrderLabel, {
          order: _ctx.order,
          orderService: _ctx.orderServiceName,
          isShowAdditionalLabel: _ctx.isShowAdditionalLabel
        }, null, 8, ["order", "orderService", "isShowAdditionalLabel"]),
        _createTextVNode(),
        (_ctx.isWatchLaterButtonVisible)
          ? (_openBlock(), _createBlock(_component_WatchLaterButton, {
              key: 0,
              class: "ml-auto",
              isShowButtonText: "",
              isRegisteredWatchLater: _ctx.isRegisteredWatchLater,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('change-watch-later', $event)))
            }, null, 8, ["isRegisteredWatchLater"]))
          : _createCommentVNode("", true)
      ]),
      _createTextVNode(),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("span", _hoisted_5, [
              (_ctx.order.hasSpecificRecommendationPoint)
                ? (_openBlock(), _createBlock(_component_BeginnerMark, {
                    key: 0,
                    class: "flex-shrink-0 beginner-mark"
                  }))
                : _createCommentVNode("", true),
              _createTextVNode(_toDisplayString(_ctx.order.title), 1)
            ])
          ]),
          _createTextVNode(),
          _createVNode(_component_RemainingDateTime, {
            expiredAt: _ctx.closestOrderWorkTimeOptionVisibleTo,
            isHiring: _ctx.order.isHiring
          }, null, 8, ["expiredAt", "isHiring"])
        ]),
        _createTextVNode(),
        (_ctx.orderImage)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(_component_BImgLazy, {
                src: _ctx.orderImage,
                alt: "",
                class: "order-card-image"
              }, null, 8, ["src"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createTextVNode(),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("ul", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleWorkTimeOptions, (option) => {
            return (_openBlock(), _createElementBlock("li", {
              key: option.id,
              class: "d-flex justify-content-between"
            }, [
              _createElementVNode("span", _hoisted_9, [
                _createVNode(_component_FeatherIcon, {
                  icon: "clock",
                  size: "16",
                  class: "ml-2 mr-1"
                }),
                _createTextVNode(_toDisplayString(_ctx.getOrderTime(option)), 1)
              ]),
              _createTextVNode(),
              _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.getSalaryPerDayWithVariousAllowances(option)) + "円", 1)
            ]))
          }), 128))
        ])
      ]),
      _createTextVNode(),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.hourlyWageLabel), 1)
      ])
    ]),
    _createTextVNode(),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.order.office.name), 1),
        _createTextVNode(),
        (_ctx.isLogin)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (_ctx.evaluation)
                ? (_openBlock(), _createBlock(_component_EvaluationWithCount, {
                    key: 0,
                    value: _ctx.evaluation.evaluationScore,
                    count: _ctx.evaluation.evaluationCount,
                    "text-size": "12",
                    size: "14"
                  }, null, 8, ["value", "count"]))
                : (_openBlock(), _createElementBlock("span", _hoisted_16, "評価データ取得中..."))
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _createTextVNode(),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _createVNode(_component_FeatherIcon, {
              icon: "map-pin",
              size: "14",
              class: "map-icon mr-1"
            }),
            _createTextVNode(),
            _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.order.office.address), 1)
          ]),
          _createTextVNode(),
          _createElementVNode("div", _hoisted_21, [
            _createVNode(_component_FeatherIcon, {
              icon: "navigation",
              size: "14",
              class: "map-icon mr-1"
            }),
            _createTextVNode(),
            _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.order.access), 1)
          ])
        ])
      ])
    ])
  ], 2))
}